import React from "react";
import "./style.css";
import { Col, Row } from "antd";
import { dentalIcons } from "../../../../../utils-icons/dentalIcons";
import { mapMatchStatus } from "../../../../../d-helper";
import { useSelector } from "react-redux";
import NoInformation from "../../../../../components/no-information/NoInformation";

const CaseResultDetailDrawerContent = ({ toothDetail }) => {
  const { metaData } = useSelector((state) => state.general);

  const renderQuadrantTitle = (q) => {
    const titles = {
      ur: "Upper Right (Quadrant)",
      ul: "Upper Left (Quadrant)",
      lr: "Lower Right (Quadrant)",
      ll: "Lower Left (Quadrant)",
    };

    return titles[q] || "Unknown Quadrant";
  };

  const dentalStructure = (condition, observation) => {
    return (
      <div className="single_case_type_info">
        <p>
          * {condition?.parentCondition?.title} (
          {condition?.parentCondition?.identifier})
        </p>
        <div className="single_case_type_info_conditon">
          <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
            <li>
              - {condition?.condition?.title}
              {condition?.serial_number &&
                ` (Serial Number: ${condition.serial_number})`}
            </li>
          </ul>
          {/* <div className="pl-6 mt-2">
            {condition?.surfaces?.map((sur) => {
              // Find the tooth from metaData.teeth using toothId
              const tooth = metaData?.teeth?.find(
                (t) => t.id === toothDetail?.tooth?.id
              );

              // Find the surface object inside the tooth
              const surface = tooth?.surfaces?.find(
                (s) => s.identifier === sur
              );

              return (
                <p className="surface_tag" key={sur}>
                  {surface ? surface.title : sur}
                </p>
              );
            })}
          </div> */}
          <div className="pl-6 mt-2 flex flex-wrap gap-2">
            {condition?.surfaces?.map((sur) => {
              const tooth = metaData?.teeth?.find(
                (t) => t.id === toothDetail?.tooth?.id
              );
              const surface = tooth?.surfaces?.find(
                (s) => s.identifier === sur
              );

              return (
                <p key={sur} className="surface_tag px-3 py-1">
                  {surface ? surface.title : sur}
                </p>
              );
            })}
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="d-case_details_container">
      <div className="case_details_body">
        <div className="case_details_header">
          <p>
            {toothDetail?.quadrant === ""
              ? "Tooth Information"
              : "Quadrant Information"}
          </p>
        </div>
        {toothDetail?.quadrant === "" ? (
          <div className="case_details_item">
            <div className="left_section">
              <p className="left_section_key">Tooth Position</p>
            </div>
            <div className="right_section">
              <p className="right_section_value">
                ISO {toothDetail?.tooth?.iso}
              </p>
            </div>
          </div>
        ) : null}
        {toothDetail?.quadrant === "" ? (
          <div className="case_details_item">
            <div className="left_section">
              <p className="left_section_key">Tooth Name</p>
            </div>
            <div className="right_section">
              <p className="right_section_value">{toothDetail?.tooth?.name}</p>
            </div>
          </div>
        ) : (
          <div className="case_details_item">
            <div className="left_section">
              <p className="left_section_key">Quadrant</p>
            </div>
            <div className="right_section">
              <p className="right_section_value">
                {renderQuadrantTitle(toothDetail?.quadrant)}
              </p>
            </div>
          </div>
        )}
        <div className="case_details_item">
          <div className="left_section">
            <p className="left_section_key">Match Status</p>
          </div>
          <div className="right_section">
            <p
              className="right_section_value"
              style={{
                color: mapMatchStatus(toothDetail?.match_status).textColor,
              }}
            >
              {mapMatchStatus(toothDetail?.match_status).statusText}
            </p>
          </div>
        </div>
        <div className="case_details_item">
          <div className="left_section">
            <p className="left_section_key">Match Score</p>
          </div>
          <div className="right_section">
            <p className="right_section_value">{toothDetail?.score}</p>
          </div>
        </div>
      </div>
      <div className="case_details_body">
        <div className="case_details_body">
          <div className="case_am_pm_detail">
            {/* AM Details */}
            <div className="case_am_pm_detail_item_row">
              <p
                className="case_type_title"
                style={{ color: "rgb(32, 195, 255)" }}
              >
                AM State
              </p>

              {toothDetail?.am_record?.conditions?.length > 0 ? (
                <>
                  {toothDetail.am_record.conditions.map((condition, index) => (
                    <div
                      key={index}
                      className="case_details_header"
                      style={{
                        background: "transparent",
                        padding: "10px 0",
                      }}
                    >
                      {dentalStructure(condition)}
                    </div>
                  ))}

                  {/* ✅ Render the observation ONCE after all conditions */}
                  <div className="single_case_type_info">
                    <div className="observation_section">
                      <p className="_title">Observations</p>
                      <div className="_observation">
                        <span>
                          {toothDetail?.am_record?.observation || "N/A"}
                        </span>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <NoInformation />
              )}
            </div>

            {/* PM Details */}

            <div className="case_am_pm_detail_item_row">
              <p
                className="case_type_title"
                style={{ color: "rgb(251, 88, 88)" }}
              >
                PM State
              </p>

              {toothDetail?.pm_record?.conditions?.length > 0 ? (
                <>
                  {toothDetail.pm_record.conditions.map((condition, index) => (
                    <div
                      key={index}
                      className="case_details_header"
                      style={{
                        background: "transparent",
                        padding: "10px 0",
                      }}
                    >
                      {dentalStructure(condition)}
                    </div>
                  ))}

                  {/* ✅ Render the observation ONCE after all conditions */}
                  <div className="single_case_type_info">
                    <div className="observation_section">
                      <p className="_title">Observations</p>
                      <div className="_observation">
                        <span>
                          {toothDetail?.pm_record?.observation || "N/A"}
                        </span>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <NoInformation />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseResultDetailDrawerContent;
